export const toHex = (d) => {
    const nb = (d * 10 * 16) / 10;
    return ('0' + Number(nb).toString(16)).slice(-2).toUpperCase();
};
